import React from 'react'
import PropTypes from 'prop-types'
import Chart from 'react-chartjs/lib/doughnut'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import countryList from '../../../countries.json'

import style from '../style'

export const TopGeo = props => {
  const options = {
    scaleShowVerticalLines: false,
    bezierCurve: false,
    offsetGridLines: true,
    showLines: false,
    maintainAspectRatio: false,
    tooltips: {
      enabled: false
    }
  }

  const _traffic = (props.traffic || [])
    .sort((a, b) => b.queries - a.queries)
    .reduce((arr, c) => {
      const _country = arr.find(_c => c.countryCode === _c.countryCode)

      return [...arr, ...(_country ? [] : [c])]
    }, [])
    .slice(0, 4)

  const totalValue = _traffic.reduce((n, obj) => n + obj.queries, 0)
  const data = _traffic.reduce(
    (arr, obj, index) => [
      ...arr,
      {
        label: (
          (countryList.find(c => c.code === obj.countryCode) || {}).name ||
          obj.countryCode
        ).slice(0, 20),
        value: obj.queries,
        color: index === 0 ? `#A94545` : `rgba(169, 69, 69, 0.5)`
      }
    ],
    []
  )

  return [
    <h3 key={0} className={css(style.headers.h3)}>
      Top viewers locations
    </h3>,
    <Row
      key={1}
      className={`${css(
        style.topgeo.box,
        style[props.theme.name] ? style[props.theme.name].topgeo.box : null
      )}`}
    >
      <Col
        xs='12'
        lg='auto'
        className={`d-flex align-items-center justify-content-center`}
      >
        <Chart
          key={1}
          data={data}
          options={options}
          width={`150px`}
          // style={{ height: `150px`, width: `150px` }}
        />
      </Col>
      <Col xs='12' lg>
        <Row
          className={`${css(
            style.topgeo.listBox,
            style[props.theme.name]
              ? style[props.theme.name].topgeo.listBox
              : null
          )}`}
        >
          {data.map((c, index) => (
            <Col
              xs='12'
              key={`${index}_country`}
              className={`
              d-flex justify-content-between
              ${css(
                style.topgeo.row,
                style[props.theme.name]
                  ? style[props.theme.name].topgeo.row
                  : null
              )}
            `}
            >
              <span
                className={`
                ${css(
                  style.topgeo.label,
                  style[props.theme.name]
                    ? style[props.theme.name].topgeo.label
                    : null
                )}
                ${css(index === 0 ? style.topgeo.firstlabel : null)}
              `}
              >
                {c.label}
              </span>
              <span
                className={`
                ${css(style.topgeo.value)}
                ${css(index === 0 ? style.topgeo.firstValue : null)}
              `}
              >
                {Number.parseInt(c.value / totalValue * 100)}%
              </span>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  ]
}

TopGeo.propTypes = {
  traffic: PropTypes.array.isRequired
}

export default TopGeo



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/TopGeo.js